module.exports = __webpack_public_path__ + "img/map.c7a66c1c.png";